import "./PostDetail.css"
import { useParams, useNavigate } from 'react-router-dom'
import { posts } from "./Posts"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

export const PostDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const post = posts.find(p => p.slug === slug);

  if (!post) {
    return (
      <div className="post-detail-container">
        <div className="post-detail-content">
          <h1>Post no encontrado</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="post-detail-container">
      <div className="post-detail-content">
        <div className="post-detail-header">
          <img src={post.image} alt={post.title} className="post-detail-image" />
          <h1>{post.title}</h1>
        </div>

        <div className="post-detail-body">
          {post.content}
        </div>
      </div>
    </div>
  )
}
